import { booleanAttribute, Component, HostBinding, Input } from '@angular/core';
import { Form, Frequency } from './interface';

@Component({
  selector: 'glxy-frequency',
  templateUrl: './frequency.component.html',
  styleUrls: ['./frequency.component.scss'],
  standalone: false,
})
export class GalaxyFrequencyComponent {
  @HostBinding('class') class = 'glxy-frequency';
  @Input({ required: true }) value = '';
  /**
   * If you want the currency code to match the text sizing of the frequency, provide it separately from the value.
   */
  @Input() currencyCode?: string;
  @Input() frequency: Frequency = Frequency.ONE_TIME;
  @Input() form: Form | 'short' | 'long' | 'verbose' = Form.SHORT;
  @Input() size: 'regular' | 'large' = 'regular';
  @Input() align: 'end' | 'start' | 'center' = 'end';
  @Input({ transform: booleanAttribute }) allowCustomStyling = false;
  Frequency = Frequency;
  Form = Form;
}
